/** Minimal typed event emitter. */
export class Emitter<E extends object> {
  private listeners = new Map<keyof E, Set<(p: never) => void>>();

  on<K extends keyof E>(name: K, fn: (payload: E[K]) => void): () => void {
    let set = this.listeners.get(name);
    if (!set) {
      set = new Set();
      this.listeners.set(name, set);
    }
    set.add(fn as (p: never) => void);
    return () => this.off(name, fn);
  }

  off<K extends keyof E>(name: K, fn: (payload: E[K]) => void): void {
    this.listeners.get(name)?.delete(fn as (p: never) => void);
  }

  emit<K extends keyof E>(name: K, payload: E[K]): void {
    const set = this.listeners.get(name);
    if (!set) return;
    for (const fn of [...set]) {
      try {
        (fn as (p: E[K]) => void)(payload);
      } catch (err) {
        console.warn(`[simple-slot] listener for "${String(name)}" threw`, err);
      }
    }
  }

  removeAll(): void {
    this.listeners.clear();
  }
}
